import { lazy } from "react";
import { Navigate } from "react-router-dom";

const LoginPage           = lazy(() => import("./pages/Login"));
const RegisterPage        = lazy(() => import("./pages/Register"));
const ForgotPasswordPage  = lazy(() => import("./pages/ForgotPassword"));
const ResetPasswordPage   = lazy(() => import("./pages/ResetPassword"));
const VerifyEmailPage     = lazy(() => import("./pages/VerifyEmail"));
const SetupPasswordPage   = lazy(() => import("./pages/SetupPassword"));

export const authRoutes = [
  { path: "/login",           element: <LoginPage /> },
  { path: "/register",        element: <RegisterPage /> },
  { path: "/forgot-password", element: <ForgotPasswordPage /> },
  { path: "/reset-password",  element: <ResetPasswordPage /> },
  { path: "/verify-email",    element: <VerifyEmailPage /> },
  { path: "/setup-password",  element: <SetupPasswordPage /> },
  { path: "/",                element: <Navigate to="/login" /> },
];
